export const EditIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.2474 20.4428H21.5"
      stroke={`${props.stroke} || #FCFF0D`}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.28 3.79479C14.0557 2.86779 15.45 2.73186 16.3962 3.49173C16.4485 3.53296 18.1295 4.83879 18.1295 4.83879C19.169 5.46719 19.492 6.80311 18.8494 7.82259C18.8153 7.87718 9.31195 19.7645 9.31195 19.7645C8.99578 20.1589 8.51583 20.3918 8.00291 20.3973L4.36353 20.443L3.54353 16.9723C3.42866 16.4843 3.54353 15.9718 3.8597 15.5773L13.28 3.79479Z"
      stroke={`${props.stroke} || #FCFF0D`}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5209 6.00098L16.9731 10.1881"
      stroke={`${props.stroke} || #FCFF0D`}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
